import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import profileApi from 'api/profile'
import audienceApi from 'api/audienceApi'
import advertisementApi from 'api/advertisementApi'
import walletApi from 'api/walletApi'
import templateApi from 'api/templateApi'
import campaignApi from 'api/campaignApi'
import channelApi from 'api/channelApi'
import dashboardApi from 'api/dashboardApi'
import enquiryApi from 'api/enquiryApi'
import companyApi from 'api/companyApi'
import rootReducer, { RootState } from './rootReducer'

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      profileApi.middleware,
      audienceApi.middleware,
      walletApi.middleware,
      advertisementApi.middleware,
      dashboardApi.middleware,
      templateApi.middleware,
      companyApi.middleware,
      campaignApi.middleware,
      channelApi.middleware,
      enquiryApi.middleware
    )
})

export type AppDispatch = typeof store.dispatch
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
export default store
